import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import NewsTeasers from "@/pages/admin/NewsTeasers";
import { buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/admin/news-teasers")({
  head: () =>
    buildSeoHead(
      { ...publicPageSeo.home, key: "admin-news-teasers", path: "/admin/news-teasers", title: "Cloud Admin News Teasers", description: "Administrationsyta" },
      [],
      { noindex: true },
    ),
  component: () => <AdminLayout><NewsTeasers /></AdminLayout>,
});
